export default __webpack_public_path__ + "static/media/IMG_1992.061c3d4f.JPG";